var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEqui(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.21,
    height: 49.207,
    viewBox: "0 0 41.21 49.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2676",
    "data-name": "Rectangle 2676",
    width: 41.21,
    height: 49.207,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M.669,31.753l-.086.95a1.371,1.371,0,0,0,1.244,1.486l1.956.175a9.285,9.285,0,0,0,2,4.322l-1.127,1.6A1.37,1.37,0,0,0,4.993,42.2l1.774,1.247a1.372,1.372,0,0,0,1.91-.333L9.806,41.5a9.383,9.383,0,0,0,4.741.423l.828,1.782a1.37,1.37,0,0,0,1.819.666l1.968-.914a1.372,1.372,0,0,0,.666-1.82L19,39.863a9.277,9.277,0,0,0,2.736-3.9l1.955.175a1.371,1.371,0,0,0,1.487-1.244l.084-.949",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M.669,31.753l.084-.95A1.369,1.369,0,0,1,2.239,29.56l1.956.174a9.292,9.292,0,0,1,2.736-3.9l-.826-1.776a1.369,1.369,0,0,1,.667-1.82l1.966-.914a1.371,1.371,0,0,1,1.821.666l.828,1.782a9.379,9.379,0,0,1,4.74.423l1.129-1.608a1.371,1.371,0,0,1,1.91-.334L20.94,23.5a1.37,1.37,0,0,1,.334,1.909l-1.127,1.6a9.281,9.281,0,0,1,2,4.322l1.956.174a1.371,1.371,0,0,1,1.243,1.487l-.085.95",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M18.839,33.372a5.9,5.9,0,1,1-5.349-6.4A5.9,5.9,0,0,1,18.839,33.372Z",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M3.7,7.035l-.248.712a1.083,1.083,0,0,0,.666,1.38l1.466.511a7.343,7.343,0,0,0,.7,3.7L5.115,14.35A1.084,1.084,0,0,0,5,15.879l1.12,1.3a1.083,1.083,0,0,0,1.528.113l1.177-1.015a7.417,7.417,0,0,0,3.553,1.24l.29,1.526a1.085,1.085,0,0,0,1.267.863l1.685-.321a1.083,1.083,0,0,0,.862-1.267L16.195,16.8a7.336,7.336,0,0,0,2.85-2.462l1.466.511a1.084,1.084,0,0,0,1.38-.666l.249-.712",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M3.7,7.035l.248-.712a1.084,1.084,0,0,1,1.38-.666L6.8,6.169A7.338,7.338,0,0,1,9.649,3.707l-.29-1.522A1.084,1.084,0,0,1,10.222.918L11.907.6a1.084,1.084,0,0,1,1.267.862l.29,1.527a7.415,7.415,0,0,1,3.553,1.239l1.177-1.014a1.083,1.083,0,0,1,1.528.113l1.12,1.3a1.083,1.083,0,0,1-.113,1.528L19.556,7.163a7.345,7.345,0,0,1,.7,3.7l1.466.511a1.085,1.085,0,0,1,.666,1.381l-.248.711",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M17.323,11.786a4.662,4.662,0,1,1-2.866-5.937A4.662,4.662,0,0,1,17.323,11.786Z",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M40.556,41.562a4.246,4.246,0,0,0-1.6-2.875l-.009-.007a2.677,2.677,0,0,1-1.026-2.107V15.341a5.358,5.358,0,0,1,1.5-3.759,4.245,4.245,0,0,0,.987-4.338A9.016,9.016,0,0,0,37.02,2.6a.215.215,0,0,0-.344.214l.89,3.99a1.976,1.976,0,0,1-.616,1.907l-.154.138a3.177,3.177,0,0,1-2.948.691l-.3-.08a1.978,1.978,0,0,1-1.41-1.478L31.26,4.018a.215.215,0,0,0-.4-.049,9.021,9.021,0,0,0-1.093,5.647A4.25,4.25,0,0,0,31.37,12.49l.009.008A2.674,2.674,0,0,1,32.4,14.6V35.837A5.36,5.36,0,0,1,30.9,39.6a4.193,4.193,0,0,0-.755,1.053,4.244,4.244,0,0,0-.232,3.284A9.019,9.019,0,0,0,33.3,48.581a.216.216,0,0,0,.344-.215l-.89-3.99a1.956,1.956,0,0,1-.042-.4c0-.043-.005-.087,0-.131a1.981,1.981,0,0,1,.661-1.381l.154-.137a3.18,3.18,0,0,1,2.948-.692l.3.081a1.981,1.981,0,0,1,1.41,1.478l.882,3.96a.215.215,0,0,0,.4.05A9.023,9.023,0,0,0,40.556,41.562Z",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqui);
export default __webpack_public_path__ + "static/media/equi.54fa08db9b300bd55f5a707d5c38c2c0.svg";
export { ForwardRef as ReactComponent };